import { Navigate } from 'react-router-dom';
import type { PortalRole } from '@denise-augusta/domain';
import { usePortalRole, canAccess } from '@/auth/roles';

/**
 * Route-level permission guard. Users without the required portal role are
 * sent back to the portal home.
 */
export function RequireRole({
  role,
  children,
}: {
  role: PortalRole;
  children: React.ReactNode;
}) {
  const userRole = usePortalRole();
  if (!canAccess(userRole, role)) {
    return <Navigate to="/portal" replace />;
  }
  return <>{children}</>;
}
